import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {Skeleton} from "@material-ui/lab";
import {Box} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";

type UserFullNameProps = {fullName: string; className?: string};

const UserFullName = ({fullName, className}: UserFullNameProps) => {
  const classes = useStyles();
  if (!fullName) {
    return (
      <FlexBox pb="0.5">
        <Skeleton animation="wave" className={classes.firstNameSkeleton} />
        <Skeleton animation="wave" className={classes.lastNameSkeleton} />
      </FlexBox>
    );
  }
  return <Box className={clsx(classes.fullName, className)}>{fullName}</Box>;
};
export default UserFullName;
